import { createApp } from 'vue';
import PdfToDocxConverter from '@/Components/PdfToDocxConverter.vue';
import '@styles/app.css';

createApp(PdfToDocxConverter).mount('#pdf-to-docx-converter');
